module.exports = __webpack_public_path__ + "img/signup-banner.b0ddb3fa.png";